<script>
  import Button from "../../../Shared/Button.svelte"
  import ApplicationState from "../../../../../../Stores/applicationStates"
  import BadgeState from "../../../Stores/badgeState"
  import { push } from "svelte-spa-router"
  import axios from "axios"
  import notify from "../../../../../../Script/notify"
  import { patchRequest } from "../../../../../../Script/apiMethods"
  export let baseCanvas
  export let loader
  export let loadingText

  let disableSaveBtn = false
  let closeNotification = {
    close() {},
  }

  const savetemplate = async () => {
    try {
      closeNotification.close()
      loader = true
      loadingText = `${$BadgeState.name} badge template saving`
      disableSaveBtn = true
      let apiObj = {}
      $BadgeState.name = $BadgeState.name.trim()
      if (!$BadgeState.name) throw "Badge template name can't be empty"
      if (!$BadgeState.operations.length) throw "Please add atleast one layer"

      for (let i = 0; i < $BadgeState.operations.length; i++) {
        if ($BadgeState.operations[i].active) $BadgeState.operations[i].active = false
        if (!$BadgeState.operations[i].value.trim()) throw "Layer Title can't be empty"
      }

      await loadFontList()

      apiObj.name = $BadgeState.name
      apiObj.width = $BadgeState.baseInfo.width
      apiObj.height = $BadgeState.baseInfo.height
      apiObj.bgColour = $BadgeState.canvasColor
      apiObj.operations = JSON.stringify($BadgeState.operations)
      apiObj.fonts = JSON.stringify($BadgeState.fonts)
      let blobObject = await canvasToBlob(baseCanvas)

      // Create a new File object with the Blob and provide a default filename and type
      let file = new File([blobObject], `${$BadgeState.name + "-" + Date.now()}.png`, {
        type: "image/png",
      })

      apiObj.file = file

      // While updating badge template
      await patchRequest(`/api/swagger/v2/templates/badges/${$BadgeState.baseInfo.id}`, apiObj, {
        headers: {
          "x-access-token": $ApplicationState.token,
          "Content-Type": "multipart/form-data",
        },
      })

      closeNotification = notify.success(`Badge Design Template <strong style="hyphens: auto;">${$BadgeState.name}</strong> saved successfully`) // Show a success notification

      push(`/templates/badge`)
      clearLocalStorage()
    } catch (error) {
      // console.error(error)
      const info = "PAGE: Badge Template Editor (Go Back Modal)\nEVENT: While updating badge template"
      closeNotification = notify.danger(error, info)
    } finally {
      loader = false
      disableSaveBtn = false
    }
  }

  /**
   * Converts a canvas element to a Blob object.
   *
   * @param {HTMLCanvasElement} canvas - The canvas element to be converted.
   * @returns {Promise<Blob>} A Promise that resolves with the generated Blob object.
   */
  const canvasToBlob = (canvas) => {
    /**
     * @typedef {Blob} Blob - Represents a binary large object (Blob) that can store binary data.
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Blob Blob}
     */

    return new Promise((resolve) => {
      /**
       * The `toBlob` method of the canvas element is used to convert it to a Blob.
       * @param {Blob} blob - The generated Blob object.
       */
      canvas.toBlob((blob) => {
        // Once the Blob is created, the Promise is resolved with the Blob object.
        resolve(blob)
      }, "image/png")
    })
  }

  const clearLocalStorage = () => {
    $BadgeState = {
      name: "",
      baseInfo: {},
      operations: [],
      fonts: [],
      apiFonts: [],
      download: false,
      cursorPosition: {
        x: 0,
        y: 0,
      },
      canvasColor: "transparent",
      activeFontStyles: [],
      activeTextAlign: "center",
      activeTextColor: "#f2072e",
      goBack: false,
      resumeModal: false,
      footer: "GENERAL",
    }
  }
  /**
   * Loads the list of fonts by sending a GET request to the server.
   * Updates the font list in the file template state.
   */
  const loadFontList = () => {
    return new Promise(async (resolve, reject) => {
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        const { data } = await axios.get("/api/swagger/v2/fonts", {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        })
        // Error checking while API call
        if (data.error && !data.success) {
          throw data.errorCode
        }

        let fontList = [...data.fonts]

        $BadgeState.fonts = []

        for (let i = 0; i < $BadgeState.operations.length; i++) {
          if ($BadgeState.operations[i].type == "text") {
            for (let j = 0; j < fontList.length; j++) {
              if (fontList[j].name == $BadgeState.operations[i].fontFamily) {
                $BadgeState.fonts = [...$BadgeState.fonts, fontList[j].id]
              }
            }
          }
        }
        $BadgeState.fonts = [...new Set($BadgeState.fonts)]

        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }
</script>

<div class="fixed inset-0 z-20 flex select-none flex-col items-center justify-center overflow-y-auto bg-[#000000cc] backdrop-blur-md transition-opacity">
  <div class="w-[500px]">
    <div class="w-full rounded-t-md bg-darkgray p-5">
      <div class="pb-6 text-center text-lg font-bold tracking-wide text-slate-100">Leave Badge Design Template Editor</div>
      <p class="pb-1 text-center text-base font-medium leading-relaxed text-gray-600">There are unsaved modifications. Would you like to save them and leave?</p>
    </div>
  </div>
  <div class="flex w-[500px] justify-evenly rounded-b-md bg-[#242424] px-5 py-3">
    <Button on:click={() => ($BadgeState.goBack = false)} text="Close" addClass="bg-red-500" iconClass="fa-circle-xmark" />
    <Button
      on:click={() => {
        push(`/templates/badge`)
        $BadgeState.goBack = false
      }}
      text="Don't save"
      addClass="bg-blue-500"
      iconClass="fa-ban"
    />
    <Button state={disableSaveBtn} on:click={savetemplate} text="Save" addClass="bg-green-500" iconClass="fa-floppy-disk" />
  </div>
</div>
